import weddingCeremonyImage from '../assets/images/Wedding Ceremony.jpg';
import preWeddingImage from '../assets/images/Prewedding.jpg';
import engagementCeremonyImage from '../assets/images/Engagement Ceremony.jpg';
import haldiImage from '../assets/images/Haldi.jpg';
import mehendiImage from '../assets/images/mehindi.jpg';
import receptionPartyImage from '../assets/images/Reception party.jpg';

const eventsData = [
  {
    id: 1,
    name: "Wedding",
    description: "Complete wedding photography coverage from rituals to reception",
    image: weddingCeremonyImage,
    duration: "Full Day"
  },
  {
    id: 2,
    name: "Pre-Wedding",
    description: "Romantic photoshoot before the wedding day",
    image: preWeddingImage,
    duration: "4-6 Hours"
  },
  {
    id: 3,
    name: "Engagement",
    description: "Capture the beautiful engagement ceremony moments",
    image: engagementCeremonyImage,
    duration: "3-4 Hours"
  },
  {
    id: 4,
    name: "Haldi",
    description: "Traditional haldi ceremony photography",
    image: haldiImage,
    duration: "2-3 Hours"
  },
  {
    id: 5,
    name: "Mehendi",
    description: "Colorful mehendi ceremony coverage",
    image: mehendiImage,
    duration: "3-4 Hours"
  },
  {
    id: 6,
    name: "Reception",
    description: "Grand reception party photography",
    image: receptionPartyImage,
    duration: "4-5 Hours"
  }
];

export default eventsData;
